export default state => ({
    ...state,
    open: false,
    message: null,
    variant: null,
    secondaryMessages: [],
});
